var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "svg-icon",
      attrs: {
        width: _vm.width,
        height: _vm.height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }
    },
    [
      _c(
        "g",
        { attrs: { fill: _vm.iconColor } },
        [
          _c(_vm.iconType, {
            tag: "component",
            attrs: { currentColor: _vm.iconColor, opacity: _vm.opacity }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }